import ContactCircleSaveModal, { CONTACT_CIRCLE_SAVE_MODAL } from './modal';

export { CONTACT_CIRCLE_SAVE_MODAL };

export default ContactCircleSaveModal;
